// extracted by mini-css-extract-plugin
module.exports = {"btns":"_1lz4qrSDXl-_GumkDTlFZ_"};